<template>
  <div v-if="showButton">
    <v-tooltip max-width="180" bottom>
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-btn
            depressed
            rounded
            color="primary"
            fab
            x-small
            @click="$emit('click')"
          >
            <v-icon size="14px">icon-youtube</v-icon>
          </v-btn>
        </div></template
      >
      <span>{{ $t("message.common.videoTutorialsTooltip") }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { PLAN_RESTRICTIONS } from "@/enums/plan-restrictions";
import { planRestrictionsCheck } from "@/helpers/plan-restrictions-check";

export default {
  name: "VideoButton",
  computed: {
    showButton() {
      return (
        this.$store.state.settings.selectedLocale === "pl" &&
        planRestrictionsCheck(PLAN_RESTRICTIONS.CAN_VIEW_TUTORIALS)
      );
    }
  }
};
</script>
